import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Truck, Sparkles, Gift, Zap, Shield, Star, Clock, Tag } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { api } from "@/api";

const ICONS = { truck: Truck, sparkles: Sparkles, gift: Gift, zap: Zap, shield: Shield, star: Star, clock: Clock, tag: Tag };

const PromoBar = () => {
  const { lang, t } = useLang();
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let mounted = true;
    api.get("/announcements").then((r) => {
      if (mounted && Array.isArray(r.data)) setItems(r.data);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const id = setInterval(() => setIdx((v) => (v + 1) % items.length), 5000);
    return () => clearInterval(id);
  }, [items.length]);

  // Fallback to translated free-shipping promo if no announcements loaded
  const current = items[idx];
  const message = current ? (current.messages?.[lang] || current.messages?.fr) : t.hero.free_shipping_promo;
  const Icon = current ? (ICONS[current.icon] || Truck) : Truck;

  return (
    <div className="bg-gradient-to-r from-blue-700 via-blue-600 to-blue-700 text-white text-center text-xs md:text-sm font-semibold py-2 px-4 overflow-hidden" data-testid="promo-bar">
      <div key={`${idx}-${message}`} className="flex items-center justify-center gap-2 animate-in fade-in slide-in-from-bottom-1 duration-500">
        <Icon className="w-3.5 h-3.5 flex-shrink-0" />
        <span data-testid="promo-bar-message">{message}</span>
      </div>
    </div>
  );
};

const Layout = ({ children }) => (
  <div className="App min-h-screen bg-black text-white">
    <PromoBar />
    <Header />
    <main data-testid="main-content">{children}</main>
    <Footer />
  </div>
);

export default Layout;
